import React from 'react';

import './styles.css';

export default function Headeline({label}) {
    return(
        <h2 className="header-line"> {label} </h2>
    );
}